/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
==========================================================================================*/

export default [
    {
        url: '/',
        name: 'Dashboard',
        slug: 'Accueil',
        icon: 'HomeIcon'
    },
    {
        url: '/deposer',
        name: 'Zone de dépôt',
        slug: 'deposer',
        icon: 'ArchiveIcon'
    },
    {
        url: '/reglement',
        name: 'Règlement',
        slug: 'reglement',
        icon: 'FileIcon'
    },
    {
        url: '/clients',
        name: 'Mes clients',
        slug: 'clients',
        icon: 'UsersIcon'
    },
    {
        url: '/factures',
        tag: 1,
        tagColor: 'success',
        name: 'Mes factures',
        slug: 'factures',
        icon: 'FileTextIcon'
    },
    {
        url: '/messagerie',
        tag: 1,
        tagColor: 'success',
        name: 'Messagerie',
        slug: 'messagerie',
        icon: 'MailIcon'
    },
    {
        url: '/profile',
        name: 'Mon compte',
        slug: 'profile',
        icon: 'UserIcon'
    }
]

